import React, { Component } from 'react';
import moment from 'moment';
import './account.scss';
import './accountContainer.scss';
//import './accountFISA.scss';

import FlipCard, {FlipCardFront} from '../../../components/FlipCard/FlipCard';
import { useUnifiedAnalytics } from '../../../contexts/AnalyticsWrapper';
import infoIcon from '../../../assets/images/info-icon.svg';
import chevDown from '../../../assets/images/chev-down-royal.svg';
import chevUp from '../../../assets/images/chev-up.svg';
import {formatCurrency} from '../../../utils/helpers';
import AccountDetails from "./AccountDetails";
import AccountActivity from '../AccountActivity/AccountActivity';
import Button from '../../../components/Form/Button/Button';

/** @extends {Component} */
class AccountFISA extends Component {
    
    state = {
        flipped: false,
        showPopupInline: null,
        accountActivitiesEnabled: false
    };
    
    toggleFisaFundingWindowInfo = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
        event.preventDefault();

        if (!this.props.showPopup(event, () => this.renderFisaFundingWindowInfo())) {
            this.setState((/** @type {{showPopupInline: string | null}} */ {showPopupInline}) => ({
                showPopupInline: showPopupInline === 'FUNDING_WINDOW' ? null : 'FUNDING_WINDOW'
            }))
        }
    };

    toggleFisaFundedInfo = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
        event.preventDefault();

        if (!this.props.showPopup(event, () => this.renderFisaFundedInfo())) {
            this.setState((/** @type {{showPopupInline: string | null}} */ {showPopupInline}) => ({
                showPopupInline: showPopupInline === 'FUNDED' ? null : 'FUNDED'
            }))
        }
    };

    calculateTimeLeft = () => {
        const { account } = this.props;
        
        if (!account.fundingWindowMinutesLeft)
            return "";

        var delta = account.fundingWindowMinutesLeft * 60;

        // calculate (and subtract) whole days
        var days = Math.floor(delta / 86400);
        delta -= days * 86400;

        // calculate (and subtract) whole hours
        var hours = Math.floor(delta / 3600) % 24;
        delta -= hours * 3600;

        // calculate (and subtract) whole minutes
        var minutes = Math.floor(delta / 60) % 60;
        delta -= minutes * 60;

        // build up the FW string
        let dayString = "0 days, ";
        let hourString = "0 hours";
        let minutesString = "0 minutes";

        if (days > 0) {
            dayString = days === 1 ? '1 day ' : `${days} days, `;
        }

        if (hours > 0) {
            hourString = hours === 1 ? '1 hour' : `${hours} hours`;
        }

        if (minutes > 0) {
            minutesString = minutes === 1 ? '1 minute' : `${minutes} minutes`;
        }

        return `${dayString}${hourString} ${minutesString}`;
    };

    renderFisaFundingWindowInfo() {
        return (
            <>
                <h3 className="account__blended-tooltip-title">Time left to add funds</h3>
                <ul className="account__blended-tooltip-items">
                    <li className="account__blended-tooltip-item">
                        You have a limited time window to add funds to your Fixed Rate Cash ISA.
                    </li>
                    <li className="account__blended-tooltip-item">
                        Once this window closes, you won't be able to make any additional deposits for the current tax year.
                    </li>
                </ul>
            </>
        );
    }

    renderFisaFundedInfo() {
        return (
            <>
                <h3 className="account__blended-tooltip-title">What does this mean?</h3>
                <ul className="account__blended-tooltip-items">
                    <li className="account__blended-tooltip-item">We'll pay your balance into an Instant Access Cash ISA and close your Fixed Rate Cash ISA. Interest will be paid into your linked account.
                    </li>
                </ul>
            </>
        );
    }

    formatMaturityDate() {
        const { account } = this.props;
        return account.maturity ? moment(new Date(account.maturity.maturityDate)).format("DD MMMM YYYY") : '';
    }

    accountIsClosed = (/** @type {string} */ status) => {
        return status === "ClosureRequested" || status === "Closed";
    }

    renderClosureMessage = (/** @type {string} */ status) => {
        if (status === "ClosureRequested")
            return 'CLOSURE IN PROGRESS';

        if (status === "Closed")
            return "CLOSED";

        return '';
    }

    renderClosureMessageSection() {
        const { account } = this.props;
        return (
            <div className="account__actions">
                <p className="account__closed-message">{this.renderClosureMessage(account.accountStatus)}</p>
            </div>
        );
    }

    renderFisaFundingWindowOpenedInfoSection() {
        const { account } = this.props;
        const timeLeft = account.fundingWindowMinutesLeft ? this.calculateTimeLeft() : '-';
        
        return (
            <div className="account__actions">
                <div>
                    <span className="account__info-key account__info-key-blue">Time left to add funds</span>
                    <span className="account__info-value">
                        <a href="#" onClick={this.toggleFisaFundingWindowInfo}>
                            <img className="account__interest-account-info" src={infoIcon} alt="Funding window information"/>
                        </a>
                    </span>
                    {this.state.showPopupInline === 'FUNDING_WINDOW' && (
                        <div className="account__inline-popup is-open">
                            {this.renderFisaFundingWindowInfo()}
                        </div>
                    )}
                </div>
                <div>
                    <span className="account__info-value">{timeLeft}</span>
                </div>
                {this.renderManageAccountButton()}
            </div>
        );
    }

    renderFisaFundedInfoSection() {
        const { account } = this.props;
        const maturityDate = account.maturity && account.maturity.maturityDate ? this.formatMaturityDate() : '-';
        
        return (
            <div className="account__actions">
                <div className="account__section-right-space">
                    <span className="account__info-key account__info-key-blue">Your term ends on</span>
                    <span className="account__info-value">
                        <a href="#" onClick={this.toggleFisaFundedInfo}>
                            <img className="account__interest-account-info" src={infoIcon} alt="Term end information"/>
                        </a>
                    </span>
                    {this.state.showPopupInline === 'FUNDED' && (
                        <div className="account__inline-popup is-open">
                            {this.renderFisaFundedInfo()}
                        </div>
                    )}
                </div>
                <div className="account__section-right-space">
                    <span className="account__info-value">{maturityDate}</span>
                </div>
                {this.renderManageAccountButton()}
            </div>
        );
    }

    renderInfoSection() {
        const { account } = this.props;
        
        if (account.accountStatus === "FundingOpen") {
            return this.renderFisaFundingWindowOpenedInfoSection();
        } else if (account.accountStatus === "Open") {
            return this.renderFisaFundedInfoSection();
        } else if (account.accountStatus === "ClosureRequested") {
            return this.renderClosureMessageSection();
        } else if (account.accountStatus === "Closed") {
            return this.renderClosureMessageSection();
        }
        
        return null;
    }

    renderAccountFront() {
        const {account, customer} = this.props;

        return (
            <div className="accountcontainer">
                <div className={this.accountIsClosed(account.accountStatus) ? "account__front account__front--closed" : "account__front"}>
                    <AccountDetails account={account} customer={customer} showPopup={this.props.showPopup} />
                    <div className="account__section-right">
                        <div className="account__balance">
                            <span className="account__balance-key">Balance</span>
                            <span className="account__balance-value" data-accountbalance-number={account.accountNumber}>
                                {formatCurrency(account.balance)}
                            </span>
                        </div>
                        {this.renderAccountLink('account__link--desktop')}
                    </div>
                    {this.renderInfoSection()}
                    {this.renderAccountLink('account__link--mobile')}
                </div>
            </div>
        );
    }

    getClassNames() {
        const {hide, disable} = this.props;
        return ['account', 'account--fisa', hide ? 'account--hidden' : '', disable ? 'account--disabled' : ''].join(' ');
    }

    onSelectActivity = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
        event.preventDefault();

        const {account, onSelectActivity} = this.props;

        this.setState((/** @type {{accountActivitiesEnabled: boolean}} */ {accountActivitiesEnabled}) => ({
            accountActivitiesEnabled: !accountActivitiesEnabled
        }), () => {
            if (typeof onSelectActivity === 'function') onSelectActivity(account);
        });
    };

    renderAccountLink(/** @type {string} */ className) {
        const {activityIsShowing} = this.props;
        let activeClass = activityIsShowing ? 'account__link--active' : '';
        return (
            <a href="#" className={["account__link", activeClass, className].join(' ')} onClick={this.onSelectActivity}>
                <span>Account activity</span>
                {this.state.accountActivitiesEnabled && <img className="account__link-icon" src={chevUp}/>}
                {!this.state.accountActivitiesEnabled && <img className="account__link-icon" src={chevDown}/>}
            </a>
        );
    };

    renderManageAccountButton() {
        const { account, analytics } = this.props;
        
        const handleManageAccountClick = () => {
            if (analytics && analytics.trackAnalyticsClickEvent) {
                analytics.trackAnalyticsClickEvent(
                    "manage your account",
                    window.location.href,
                    "FISA account card",
                    "fisa_1yr",
                    account.id,
                    {},
                    "button click",
                    "dashboard|click|manage-fisa-account",
                    "dashboard"
                );
            }
            window.location.href = "account-details/" + account.id;
        };
        
        return (
            <Button
                size="med"
                label="Manage your account"
                onClick={handleManageAccountClick}
            />
        );
    }

    render() {
        const {flipped} = this.state;
        const {account, activityIsShowing, activityRef, accountWithActionInProgress} = this.props;

        return (
            <>
                <div className={this.getClassNames()}>
                    <FlipCard flipped={flipped}>
                        <FlipCardFront>{this.renderAccountFront()}</FlipCardFront>
                    </FlipCard>
                </div>
                {this.state.accountActivitiesEnabled &&
                    <AccountActivity activityRef={activityRef} account={account} disable={Boolean(accountWithActionInProgress)}/>}
            </>
        );
    }
}

// Wrapper component to inject analytics
const AccountFISAWithAnalytics = (/** @type {any} */ props) => {
    const analytics = useUnifiedAnalytics();
    return <AccountFISA {...props} analytics={analytics} />;
};

export default AccountFISAWithAnalytics;
